<template>
  <div>
    <v-card class="pa-4">
      <div class="text-xs-right">
        <v-btn @click="cancelImport" icon ripple class="primary">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <h5 class="mb-4">Add voucher codes</h5>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right pt-1">
            <!-- <exportxlsx :promisedValue="getXlsxData" :filename="selectedData"></exportxlsx> -->
            <v-btn @click="getImportTemplate" color="primary">
              <span>Download Template</span>
            </v-btn>
            <div style="font-size: 12px" class="primary--text pr-2">
              <span class="red--text">*</span> Template for import code
            </div>
          </v-flex>
          <v-flex xs12 sm12 class="form-control pa-1">
            <div class="form-control" :class="{ 'has-error': errors.has('intentInput') }">
              <label for="intentInput" class="caption">
                {{ $t('Reply comment intent name') }}<span class="red--text">*</span>
              </label>
              <multiselect
                v-model="input.intent"
                :options="value"
                label="intentname"
                name="intentInput"
                selectLabel
                selectedLabel
                :allow-empty="false"
                :searchable="false"
                deselect-label
                track-by="intentname"
                v-validate="'required'"
              ></multiselect>
              <span class="text-error" v-show="errors.has('intentInput')">
                {{ errors.first('intentInput') }}
              </span>
            </div>
          </v-flex>
          <v-flex xs12 sm12 class="form-control pa-1">
            <div class="form-control" :class="{ 'has-error': errors.has('importCodeInput') }">
              <div>
                <label for="importCodeInput" class="caption"
                  >{{ $t('Import Code') }} <span class="red--text">*</span></label
                >
              </div>
              <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
              <span v-if="importCodeStatus" class="green--text">Upload file successfully</span>
              <div class="text-error red--text" style="font-size: 12px" v-show="errorUploadFile">
                กรุณาอัปโหลดไฟล์
              </div>
            </div>
            <span class="text-error red--text" v-show="errors.has('importCodeInput')">
              {{ errors.first('importCodeInput') }}
            </span>
          </v-flex>
          <v-flex xs12 sm12 class="form-control pa-1">
            <div class="form-control">
              <label for="StartDate" class="caption">{{ $t('Start Date') }}</label>
              <v-layout>
                <v-flex xs10 sm10>
                  <DatepickerCustomDialog v-model="input.start_date">
                    <input type="text" readonly :value="getDateFormatted(input.start_date)" />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs2 sm2>
                  <v-btn @click="clearDateTime('StartDate')" icon> <v-icon>delete</v-icon></v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs12 sm12 class="form-control pa-1">
            <div class="form-control">
              <label for="EndDate" class="caption">{{ $t('End Date') }}</label>
              <v-layout>
                <v-flex xs10 sm10>
                  <DatepickerCustomDialog v-model="input.end_date">
                    <input type="text" readonly :value="getDateFormatted(input.end_date)" />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs2 sm2>
                  <v-btn @click="clearDateTime('EndDate')" icon> <v-icon>delete</v-icon></v-btn>
                </v-flex>
              </v-layout>
              <span class="text-error" v-show="errors.has('EndDate')">
                {{ errors.first('EndDate') }}
              </span>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="cancelImport">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" :loading="saveLoading" @click="saveImportCode">{{
          $t('Save')
        }}</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import importxlsx from '@/components/elements/importxlsx.vue'
import datepicker from 'vuejs-datepicker'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import XLSX from 'xlsx'

export default {
  props: ['value'],
  components: {
    Multiselect,
    importxlsx,
    datepicker,
    DatepickerCustomDialog
  },
  data() {
    return {
      intentOptions: this.value,
      importloading: false,
      importCodeStatus: false,
      input: {
        intent: '',
        importCode: '',
        start_date: '',
        end_date: ''
      },
      errorUploadFile: false,
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    getImportTemplate() {
      let json = []

      let output = {
        code: '',
        'number of days': ''
      }

      json.push(output)

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'plern-import-code-template' + '.xlsx')
    },
    onImport(item) {
      var vm = this
      vm.importloading = true
      vm.input.importCode = item[0]
      vm.importloading = false
      vm.importCodeStatus = true
      vm.errorUploadFile = false
    },
    async saveImportCode() {
      var vm = this
      var result = await vm.$validator.validateAll()

      if (vm.input.importCode == '') {
        vm.errorUploadFile = true
      } else {
        vm.errorUploadFile = false
      }

      if (!result) {
        vm.goToErrorInput()
        return false
      }

      vm.saveLoading = true
      var data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.input.intent.intentname,
        intentid: vm.input.intent.id,
        data: vm.input.importCode
      }

      if (vm.input.start_date) {
        Object.assign(data, { start_date: moment(vm.input.start_date).format('YYYY-MM-DD') })
      }

      if (vm.input.end_date) {
        Object.assign(data, { end_date: moment(vm.input.end_date).format('YYYY-MM-DD') })
      }

      await api.postPlernImportCode(data, async (err, response) => {
        if (err) {
          vm.saveLoading = false
          console.log(err)
          return
        }

        if (response.responsecode == 200) {
          vm.saveLoading = false
          await this.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })

          this.$emit('close')
          this.$emit('success')
          this.reset()
        } else {
          vm.saveLoading = false
          console.log(err)
          return
        }
      })
    },
    clearDateTime(val) {
      if (val == 'StartDate') {
        this.input.start_date = ''
      } else {
        this.input.end_date = ''
      }
    },
    cancelImport() {
      this.$emit('close')
      this.reset()
    },
    reset() {
      this.input = {
        intent: '',
        importCode: '',
        start_date: '',
        end_date: ''
      }
      this.importCodeStatus = false
      this.errorUploadFile = false
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/plern/ImportCodeModal.vue